module.exports = __webpack_public_path__ + "static/media/Non-food-overig.c9044072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Non-food-overig.jpg
// module id = 329
// module chunks = 0